/**
 * Mobile buy bar — fastgjort købsbjælke med pris og knap på mobil.
 *
 * Forskel fra temaets egen <product-sticky-bar>: den vises kun når købsknappen
 * er scrollet FORBI (boundingClientRect.bottom < 0). Denne vises når knappen er
 * ude af syne i begge retninger — også i første skærm, hvor knappen ligger under
 * folden. Den skjules når knappen eller footeren er i syne.
 *
 * Bruges kun af templates, der renderer snippets/mobile-buy-bar.liquid.
 */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('mobile-buy-bar')) return;

  customElements.define('mobile-buy-bar', class extends HTMLElement {
    connectedCallback() {
      // Flyt baren ud til <body>. Står den inde i produktinfo, kan en forfader med
      // transform/contain få position: fixed til at opføre sig som absolute.
      // Flytningen udløser connectedCallback igen, derfor returneres der her.
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }
      if (this.observer) return;

      var formId = this.getAttribute('form');
      // Observer selve købsknapperne i produktinfo — ikke formularen, som kan ligge et helt andet sted
      this.target =
        document.querySelector('.product-info buy-buttons[form="' + formId + '"]') ||
        document.getElementById(formId);
      this.footer = document.querySelector('.shopify-section--footer');
      if (!this.target) return;

      this.targetVisible = true;
      this.footerVisible = false;

      var self = this;
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.target === self.target) self.targetVisible = e.isIntersecting;
          if (e.target === self.footer) self.footerVisible = e.isIntersecting;
        });
        self.classList.toggle('is-visible', !self.targetVisible && !self.footerVisible);
      });
      this.observer.observe(this.target);
      if (this.footer) this.observer.observe(this.footer);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
})();
